import { render } from "./DirectConnect.vue?vue&type=template&id=39d1b34c"
import script from "./DirectConnect.vue?vue&type=script&lang=js"
export * from "./DirectConnect.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__